
import React, { useEffect, useState, memo, useCallback } from "react";
import ScrollMenu from "react-horizontal-scrolling-menu";
import { injectIntl } from "react-intl";

import "./style.scss";

import { useIsMobile } from "../../../hooks/useIsMobile";

const MenuItem = memo(({ title, diceClass, index, toggleActiveItem, selected }) => {
  const Title = useCallback(() => {
    let list = title.split(" ");
    list.length > 1 && (list = [list.shift(), list.join(" ")]);
    return (
      <label>
        {list.map((line, index) => (
          <React.Fragment key={index}>
            {index === 0 ? `${line} ` : <span>{line}</span>}
          </React.Fragment>
        ))}
      </label>
    );
  }, [title]);

  return (
    <div
      className={`DicesMenu-Item ${selected ? "DicesMenu-Item-Active" : ""}`}
      onClick={() => toggleActiveItem(index)}
    >
      <div
        className={`DicesMenu-Item-Image DiceMenu-Icon-${diceClass} ${
          selected ? "DicesMenu__item active" : "DicesMenu__item"
        }`}
      />
      <Title />
    </div>
  );
});


const DicesMenu = ({ items, itemActive, handleOnClick, intl }) => {
  const { isMobile } = useIsMobile();
  const [selected, setSelected] = useState(itemActive || 0);

  const onSelect = useCallback((key) => {
    let el = document.querySelectorAll(".DicesSlider__slide")[Number(key)];
   if (el) {
    const { left } = el.getBoundingClientRect();
    let drop = document.querySelector(".DicesSlider-Drop");
    const position = drop.scrollLeft + left;
    drop.scroll({left: position > 15 ? position - 15 : position, behavior: "smooth" });
   }
    setSelected(key);
  }, [setSelected]);

  const toggleActiveItem = useCallback((index) => {
    handleOnClick(index);
  }, [handleOnClick]);

  useEffect(() => {
    var el = document.querySelectorAll(".DicesSlider__slide")[itemActive];
    if (el) {
      var active = document.querySelector(
        ".DicesSlider__slide.DicesSliderActive"
      );
      active && active.classList.remove("DicesSliderActive");
      el.classList.add("DicesSliderActive");

      if (isMobile) {
        setSelected(Number(itemActive));
      }
    }
  }, [itemActive]);

  return (
    <div className="DicesMenu">
      {!isMobile ? (
        items
          .filter(({ dices }) => dices.length)
          .map(({ title, category }, i) => (
            <MenuItem
              diceClass={category}
              key={i}
              title={intl.formatMessage({id: `Categories.${title}`})}
              index={i}
              toggleActiveItem={toggleActiveItem}
              selected={itemActive === i}
            />
          ))
      ) : (
        <ScrollMenu
          data={items
            .filter(({ dices }) => dices.length)
            .map(({ title, category }, i) => (
              <MenuItem
                diceClass={category}
                key={i}
                title={intl.formatMessage({id: `Categories.${title}`})}
                index={i}
                toggleActiveItem={toggleActiveItem}
                selected={itemActive === i}
              />
            ))}
          selected={selected}
          onSelect={onSelect}
          alignCenter={true}
          scrollToSelected={true}
          wheel={true}
        />
      )}
    </div>
  );
};

export default injectIntl(memo(DicesMenu));
